<template>
  <div class="bg-white create-partner">
    <div class="flex justify-between items-stretch shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto">
        <p class="font-bold text-lg mb-6">Tambah Business Merchant</p>
        <div class="mb-6 max-w-sm">
          <TextField type="text" label="ID" :disabled="true" v-model="id" />
        </div>
        <div class="mb-6">
          <TextField
            type="text"
            label="Nama Perusahaan/Company Name"
            notes="Pastikan nama perusahaan belum terdaftar sebelumnya (duplikasi)."
            v-model="payloads.name"
            placeholder="Nama perusahaan"
            required
          />
        </div>
        <div class="mb-6">
          <TextField type="text" label="Nama Admin Pengirim" v-model="payloads.sender_name" placeholder="Masukan nama admin" required />
        </div>
        <div class="mb-6">
          <TextField type="text" label="Email" v-model="payloads.email" placeholder="Masukan email" required />
        </div>
        <div class="mb-6">
          <TextField type="number" label="No. Handphone" v-model="payloads.sender_phone" placeholder="Masukan no handphone" required />
        </div>
        <div class="mb-6">
          <TextField
            type="text"
            label="Password (optional)"
            notes="Jika password tidak diisi maka sistem akan mengirimkan password sementara ke email yang terdaftar."
            v-model="payloads.password"
            placeholder="Masukan password"
          />
        </div>
      </div>
      <div class="flex-1 mdmax:w-full mdmax:flex-auto">
        <div class="p-6">
          <div class="mb-6">
            <TextField type="text" label="Label Alamat (optional)" v-model="payloads.address_label" placeholder="Masukan label alamat" />
          </div>
          <div class="mb-6">
            <Textarea type="text" label="Pickup Point/Alamat Pengiriman (Sertakan Kecamatan & Kelurahan)" v-model="payloads.pickup_address" placeholder="Masukan alamat pengiriman" required />
          </div>
          <div class="mb-6">
            <TextField type="text" label="Petunjuk Pengiriman" v-model="payloads.detail_address" placeholder="Masukan petujuk sebagai patokan" />
          </div>
          <div class="mb-6 text-left relative">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block"><span class="text-system-error">*</span>Kota / Kecamatan / Kode POS Pengirim</label>
            <div class="relative">
              <TextField withIcon type="text" @input="searchCity($event)" v-model="destinationSearch" placeholder="Kota / Kecamatan / Kode POS Pengirim" />
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
                <Search />
              </div>
              <img src="@/assets/images/rolling.gif" class="w-8 absolute top-1/2 transform -translate-y-1/2 right-2" v-if="isSearching" />
              <transition name="fade" mode="out-in">
                <div class="mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white" v-if="visibleSuggestion">
                  <ul v-if="cities" class="max-h-40 overflow-y-scroll">
                    <li class="cursor-pointer px-3 py-2 hover:bg-neutral-300" v-for="(city, index) in cities" :key="'city-' + index" @click="selectCity(city)">
                      {{ city.village }}, {{ city.area_display }}
                    </li>
                  </ul>
                  <div class="py-4 text-center" v-else>Maaf data tidak ditemukan!</div>
                </div>
              </transition>
            </div>
          </div>
          <div class="mb-6">
            <TextField type="text" label="Koordinat Alamat (optional)" v-model="payloads.latlng" placeholder="Latitude, Longitude" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end">
      <Button buttonText="Simpan" @action="submit()" :size="isMobile ? 'full' : 'regular'" :disabled="isDisabled" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { showVueToast } from '@/util'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Textarea: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Textarea'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    Button: () => import(/* webpackChunkName: "button" */ '@/components/Forms/Button')
  },
  data() {
    return {
      id: 0,
      selectedType: null,
      selectedBank: null,
      contract_start: null,
      contract_end: null,
      payloads: {
        email: null,
        name: null,
        sender_name: null,
        sender_phone: null,
        pickup_address: null,
        address_label: '',
        detail_address: '',
        password: '',
        latlng: '',
        area_code: null
      },
      debounce: null,
      destination: '',
      destinationSearch: '',
      cityKeyword: null,
      visibleSuggestion: false,
      isSearching: false
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('master', ['cities']),
    isDisabled() {
      return !this.payloads.email || !this.payloads.name || !this.payloads.sender_name || !this.payloads.sender_phone || !this.payloads.pickup_address || !this.payloads.area_code
    }
  },
  created() {},
  methods: {
    ...mapActions('common', ['setToast', 'showLoading', 'hideLoading']),
    ...mapActions('master', ['getCities']),
    ...mapActions('merchant', ['addMerchant']),
    submit() {
      const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      if (!regex.test(this.payloads.email)) {
        showVueToast('Format email tidak valid!', 'error', 3000)
        return
      }
      this.showLoading()
      console.log(this.payloads)
      this.addMerchant({
        payloads: this.payloads
      })
        .then(() => {
          this.hideLoading()
          this.setToast({
            options: { type: 'success', duration: 2000, primaryText: 'Penambahan Merchant Berhasil', secondaryText: 'Data telah kami simpan', callback: this.handleCallback }
          })
        })
        .catch(() => {
          this.hideLoading()
          showVueToast('Terjadi kesalahan!', 'error', 3000)
        })
    },
    handleCallback() {
      this.$router.push('/merchant')
    },
    searchCity(value) {
      this.cityKeyword = null
      if (value) this.isSearching = true
      this.visibleSuggestion = false
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        if (value) {
          this.cityKeyword = value
          this.getCities({
            params: {
              page: 1,
              per_page: 1000,
              search_keyword: this.cityKeyword
            }
          }).then(() => {
            this.visibleSuggestion = true
            this.isSearching = false
          })
        }
      }, 200)
    },
    selectCity(data) {
      this.payloads.area_code = data.code
      this.destinationSearch = `${data.village}, ${data.area_display}`
      this.visibleSuggestion = false
    }
  }
}
</script>
<style lang="scss" scoped>
.create-partner {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }
  &::v-deep .vdpComponent {
    font-size: 14px;
    display: block;
  }
  &::v-deep .vdpComponent input {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 2.25rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
}
</style>
